import { IconButton, Tooltip } from '@material-ui/core';
import { useMemo, useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SubjectIcon from '../../../component/icon/SubjectIcon';
import BreadCrumb from '../../../component/BreadCrumb';
import SelectionBox from '../../../component/SelectionBox';
import CodeUtil from '../../../util/CodeUtil';
import { CODE_GROUP_ID, ENROLMENT_REG_STATUS } from '../../../constant/Constant';

import GridTimeBox from '../../../component/GridTimeBox';
import DeleteIcon from '../../../component/icon/DeleteIcon';
import StatusTextIconBox from '../../../component/StatusTextIconBox';
import { StatusSpanIconBox } from '../../../component/StatusTextIconBox';

import EnrolmentProcessStatus from '../../../component/EnrolmentProcessStatus';
import PdfViewModal from '../../modal/PdfViewModal';
import ModalRef from '../../../component/ModalRef';
import PopupRef from '../../../component/PopupRef';
import SubjectDetailModal from '../../modal/SubjectDetailModal';
import { modalType } from '../../../util/ModalUtil';
import EnrolmentUniversityStatusBox from '../../../component/EnrolmentUniversityStatusBox';
import {
    actionEnrolmentResultSearch,
    actionEnrolmentResultRemove,
    actionEnrolmentResultByUniversitySearch,
    actionEnrolmentResultSemesterUserInfoSearch,
} from '../../../module/body/enrolment/EnrolmentEnrolmentResultModule';
import SessionStorageUtil from '../../../util/SessionStorageUtil';
import { VIEW_ENROLMENT_ENROLMENT_RESULT } from './../../../constant/ViewConstant';
import SearchButtonBox from '../../../component/buttons/SearchButtonBox';
import AuthenticationUtil from '../../../util/AuthenticationUtil';
import NullCheckUtil from '../../../util/NullCheckUtil';
import { handleNoPageControl, initNoPageGrid } from '../../../module/component/TableNoPageBoxModule';
import TableNoPageBox from '../../../component/TableNoPageBox';
import { actionEnrolmentResultSemesterInfoSearch } from '../../../module/body/enrolment/EnrolmentEnrolmentResultModule';
import { OpenDetailIcon } from '../../../component/icon/GridIcons';
import GridButtonBox from '../../../component/buttons/GridButtonBox';

const ConditionArea = ({ popupRef, modalRef }) => {
    const dispatch = useDispatch();
    const userId = AuthenticationUtil.getUserId();
    const [semesterId, setSemesterId] = useState();
    const [params, setParams] = useState({});

    useEffect(() => {
        dispatch(
            handleNoPageControl({
                columns,
                onRowDoubleClick,
                params,
            }),
        );

        setSemesterId(SessionStorageUtil.getCurrentSemesterId());

        onClickSearch({ semesterId: SessionStorageUtil.getCurrentSemesterId(), userId });

        return () => {
            dispatch(initNoPageGrid());
        };
    }, []);

    useEffect(() => {
        dispatch(
            handleNoPageControl({
                columns,
                onRowDoubleClick,
                params,
            }),
        );
    }, [params]);

    const onClickSearch = (params) => {
        setParams(params);
        dispatch(actionEnrolmentResultSemesterInfoSearch({ params }));
        dispatch(
            actionEnrolmentResultSearch({
                params: {
                    ...params,
                    page: 0,
                    pageSize: 100,
                },
                callback: (result) => {
                    if (NullCheckUtil.isNotNull(result) && result.totalCount == 0) {
                        popupRef.current.openAlert('조회된 수강신청 결과가 없습니다.');
                    }
                },
            }),
        );
        dispatch(actionEnrolmentResultByUniversitySearch({ params }));
        dispatch(actionEnrolmentResultSemesterUserInfoSearch({ params }));
    };

    const onRowDoubleClick = (row, params) => {
        modalRef.current.open(
            <SubjectDetailModal
                type={modalType.DETAIL}
                searchParams={{
                    semesterId: row.semesterId,
                    lessonUniversityCd: row.lessonUniversityCd,
                    subjectId: row.subjectId,
                    classNo: row.classNo,
                    universitySubjectId: row.universitySubjectId,
                }}
                callback={() => {
                    onClickSearch(params);
                }}
                modalRef={modalRef}
            />,
            'large',
        );
    };

    const handleSubjectfView = (row) => {
        if (NullCheckUtil.isEmpty(row.lessonPlanFileUid)) {
            popupRef.current.openAlert('강의계획서가 등록되어 있지 않습니다.');
        } else {
            modalRef.current.open(
                <PdfViewModal fileUid={row.lessonPlanFileUid} fileSize={row.lessonPlanFileSize} modalRef={modalRef} />,
                'large',
            );
        }
    };

    const handleDeleteSubject = (row, params) => {
        popupRef.current.openWarning(`${row.subjectNm}의 수강신청을 취소하시겠습니까?`, () => {
            return function () {
                dispatch(
                    actionEnrolmentResultRemove({
                        data: {
                            semesterId: row.semesterId,
                            lessonUniversityCd: row.lessonUniversityCd,
                            subjectId: row.subjectId,
                            classNo: row.classNo,
                            userId: AuthenticationUtil.getUserId(),
                            universitySubjectId: row.universitySubjectId,
                        },
                        callback: () => {
                            popupRef.current.openAlert('수강신청이 취소되었습니다.', () => {
                                return function () {
                                    onClickSearch(params);
                                };
                            });
                        },
                    }),
                );
            };
        });
    };

    const onKeyDown = (e) => {
        if (e.key == 'Enter') {
            onClickSearch({
                semesterId,
                userId,
            });
        }
    };

    const columns = useMemo(
        () => [
            {
                field: 'lessonUniversityCd',
                headerName: '개설대학',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 12,
                renderCell: (params) =>
                    CodeUtil.getCodeName(CODE_GROUP_ID.MAIN_UNIVERSITY, params.row.lessonUniversityCd),
            },
            {
                field: 'subjectTypeCd',
                headerName: '과정구분',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 15,
                renderCell: (params) => CodeUtil.getCodeName(CODE_GROUP_ID.SUBJECT_TYPE, params.row.subjectTypeCd),
            },
            {
                field: 'subjectNm',
                headerName: '교과목',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 15,
            },
            { field: 'classNo', headerName: '분반', headerAlign: 'center', align: 'center', tooltip: true, flex: 6 },
            {
                field: 'profNm',
                headerName: '교강사',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            // { field: 'lessonYear', headerName: '학년', headerAlign: 'center', align: 'center', tooltip: true, flex: 6 },
            { field: 'creditCnt', headerName: '학점', headerAlign: 'center', align: 'center', tooltip: true, flex: 6 },
            {
                field: 'lessonTypeCd',
                headerName: '수업방식',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 12,
                renderCell: (params) => CodeUtil.getCodeName(CODE_GROUP_ID.LESSON_TYPE, params.row.lessonTypeCd),
            },
            {
                field: 'courseTimes',
                headerName: '강의시간',
                headerAlign: 'center',
                tooltip: true,
                flex: 24,
                renderCell: (params) => <GridTimeBox times={params.row.courseTimes} />,
            },
            {
                field: 'enrolmentRegStatusCd',
                headerName: '수강신청 등록상태',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 15,
                renderCell: (params) => (
                    <StatusTextIconBox
                        codeGroup={CODE_GROUP_ID.ENROLMENT_REG_STATUS}
                        statusCd={params.row.enrolmentRegStatusCd}
                    />
                ),
            },
            {
                field: 'detail',
                headerName: '기능',
                headerAlign: 'center',
                align: 'center',
                flex: 20,
                disableColumnMenu: true,
                hideSortIcons: true,
                disableExport: true,
                renderCell: (item) => (
                    <>
                        <Tooltip title='상세'>
                            <IconButton onClick={() => onRowDoubleClick(item.row, params)}>
                                <OpenDetailIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title='강의계획서 보기'>
                            <IconButton onClick={(e) => handleSubjectfView(item.row)}>
                                <SubjectIcon />
                            </IconButton>
                        </Tooltip>
                        <GridButtonBox
                            title='신청취소'
                            btnStyle='RED-BORDER'
                            onClick={(e) => handleDeleteSubject(item.row, params)}
                        />
                    </>
                ),
            },
        ],
        [params],
    );

    return (
        <div>
            <div className='con-form-wrap'>
                <div className='board-inner pd30'>
                    <div className='board-row'>
                        <div className='lec-check-box'>
                            <div className='form-box-container'>
                                <SelectionBox
                                    title='학기'
                                    value={semesterId}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.SEMESTER)}
                                    onChange={(e) => setSemesterId(e.target.value)}
                                    useAll={false}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                            </div>
                            <div className='lec-check-btn'>
                                <SearchButtonBox
                                    title='조회'
                                    onClick={(e) =>
                                        onClickSearch({
                                            semesterId,
                                            userId,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const Main = () => {
    const { semesterInfo } = useSelector((state) => state.enrolmentResultState);
    const { semesterUserInfo, univData } = useSelector((state) => state.enrolmentResultState);
    return (
        <>
            <div className='con-tb-wrap appli-result-wrap'>
                <div className='con-tb-title'>
                    <h3 className='tb-tit-name'>수강신청 진행 단계</h3>
                </div>
                <div className='apply-step-inner'>
                    <ul className='explain-txt'>
                        <li>
                            학생 수강신청 이후 본교(학생 소속대학)에서 수강자격 검증이 진행되며, 수강자격 검증 후 과목
                            개설대학에서 수강등록이 처리됩니다. 현재 수강신청 진행단계는 아래와 같습니다.
                        </li>
                    </ul>
                    <EnrolmentProcessStatus semesterInfo={semesterInfo} />
                </div>
                <div className='con-tb-title'>
                    <h3 className='tb-tit-name'>
                        수강신청 목록
                        {semesterUserInfo.enrolmentValidStatusCd && (
                            <div className='tb-tit-sub-txt'>
                                ( 본교 수강검증 상태 :
                                <StatusSpanIconBox
                                    codeGroup={CODE_GROUP_ID.ENROLMENT_VALID_STATUS}
                                    statusCd={semesterUserInfo.enrolmentValidStatusCd}
                                />
                                )
                            </div>
                        )}
                    </h3>
                </div>
                <div className='apply-tb-inner'>
                    <ul className='explain-txt'>
                        <li>수강신청 목록을 확인하고 수강신청 기간 중에는 신청한 과목을 취소할 수 있습니다.</li>
                    </ul>
                </div>
            </div>
            <TableNoPageBox defaultWide={false} />
            <div className='con-tb-wrap appli-result-wrap'>
                <div className='con-tb-title'>
                    <h3 className='tb-tit-name'>대학별 수강등록 상태</h3>
                </div>
                <div className='apply-univ-inner'>
                    <ul className='explain-txt'>
                        <li>
                            각 대학별 수강신청 등록 처리 결과 및 각 대학의 추가적인 안내메시지를 확인할 수 있습니다.
                        </li>
                    </ul>
                    {NullCheckUtil.isEmpty(univData) ? (
                        <div className='univ-status-box'>
                            <span>혁신융합대학사업(미래자동차) 수강신청이 존재하지 않습니다.</span>
                        </div>
                    ) : (
                        univData.map((row, index) => (
                            <EnrolmentUniversityStatusBox key={index} enrolmentUniversity={row} />
                        ))
                    )}
                </div>
            </div>
        </>
    );
};

const EnrolmentEnrolmentResultView = () => {
    const popupRef = useRef(null);
    const modalRef = useRef(null);

    return (
        <div className='body-view'>
            <section className='container'>
                <div className='container-inner'>
                    <div className='con-title-wrap conbg01'>
                        <h2 className='con-title'>{VIEW_ENROLMENT_ENROLMENT_RESULT.title}</h2>
                        <p className='con-title-p'>{VIEW_ENROLMENT_ENROLMENT_RESULT.subTitle}</p>
                    </div>
                    <div className='sub-nav-wrap'>
                        <BreadCrumb />
                    </div>
                    <ConditionArea popupRef={popupRef} modalRef={modalRef} />
                    <Main />
                </div>
            </section>
            <PopupRef ref={popupRef} />
            <ModalRef ref={modalRef} />
        </div>
    );
};

export default EnrolmentEnrolmentResultView;
